const entity = {
  name: {
    singular: 'Contato',
    plural: 'Contatos'
  },
  options: {
    importCSV: true
  },
  collection: 'contacts',
  tableHeaders: [
    { text: 'Nome', value: 'fullName' },
    { text: 'CPF', value: 'cpf' },
    { text: 'Celular', value: 'cellphone' },
    { text: 'Bairro', value: 'neighborhood' },
    { text: 'Cidade', value: 'city' },
    { text: 'Religião', value: 'religiao' },
    { text: 'Actions', value: 'action', sortable: false }
  ],
  model: {
    firstName: '',
    fullName: '',
    cpf: '',
    email: '',
    cellphone: '',
    address: '',
    neighborhood: '',
    zipcode: '',
    city: '',
    state: '',
    status: {},
    accountId: '',
    additionalData: []
  },
  config: {
    name: 'Config',
    hasPreview: true,
    fields: [
      {
        type: 'switch',
        label: 'Ingresso Sexta',
        model: 'additionalData.tickets.friday',
        required: true,
        size: 'lg12'
      },
      {
        label: 'Valor',
        model: 'price',
        size: 'lg6',
        inputMask: 'money',
        inputMaskOptions: {
          prefix: 'RS',
          precision: 2,
          locale: 'en'
        }
      },
      {
        type: 'date-picker',
        label: 'Data de Entrada',
        hint: 'Deixe em branco caso não tenha data limite.',
        model: 'dateIn',
        required: false,
        size: 'lg6'
      },
      {
        type: 'switch',
        label: 'Ingresso Sábado',
        model: 'additionalData.tickets.friday',
        required: true
      },
      {
        label: 'Price',
        model: 'price',
        size: 'lg6',
        inputMask: 'money',
        inputMaskOptions: {
          prefix: 'USD',
          precision: 2,
          locale: 'en'
        }
      },
      {
        type: 'date-picker',
        label: 'Data de Entrada',
        hint: 'Deixe em branco caso não tenha data limite.',
        model: 'dateIn',
        required: false,
        size: 'xs12 sm12 md6 lg6'
      }
    ]
  },
  schema: {
    groups: [
      {
        name: 'Detalhes',
        fields: [
          { type: 'text-field', size: 'xs12 sm12 md12 lg3', label: 'Primeiro nome', model: 'firstName' },
          { type: 'text-field', size: 'xs12 sm12 md12 lg9', label: 'Nome completo', model: 'fullName' },
          { type: 'text-field', size: 'xs12 sm12 md12 lg3', label: 'CPF', model: 'cpf', readOnly: true },
          { type: 'text-field', size: 'xs12 sm12 md12 lg6', label: 'Bairro', model: 'neighborhood' },
          { type: 'text-field', size: 'xs12 sm12 md12 lg3', label: 'Celular', model: 'cellphone' },
          { type: 'text-field', size: 'xs12 sm12 md12 lg3', label: 'Religião', model: 'additionalData.religiao', readOnly: true },
          { type: 'text-field', size: 'xs12 sm12 md12 lg3', label: 'Cidade/UF', model: 'city' }
        ]
      },
      {
        name: 'Adicionais',
        fields: [
          {
            type: 'array',
            label: 'Adicionais',
            model: 'additionalData.additionals',
            arrayOf: {
              fields: [
                { type: 'text-field', label: 'Nome', model: 'nome' },
                { type: 'text-field', label: 'CPF', model: 'cpf' },
                { type: 'text-field', label: 'Celular', model: 'tel' },
                { type: 'text-field', label: 'Bairro', model: 'bairro' },
                { type: 'text-field', label: 'Cidade/UF', model: 'cidade' },
                { type: 'text-field', label: 'Religião', model: 'religiao' }
              ]
            }
          }
        ]
      }
    ]
  },
  formOptions: {
    validateAfterLoad: false,
    validateAfterChanged: false,
    validateAsync: false
  }
}

export default [
  {
    path: '/contacts',
    meta: {
      entity,
      requiresAuth: true,
      requiresPermissionTo: 'contacts',
      crud: 'list'
    },
    component: () => import(/* webpackChunkName: 'contacts' */ '../../../views/Crud.vue')
  }, {
    path: '/contacts/new',
    meta: {
      entity,
      requiresAuth: true,
      requiresPermissionTo: 'contacts',
      crud: 'form'
    },
    component: () => import(/* webpackChunkName: 'contacts' */ '../../../views/Crud.vue')
  }, {
    path: '/contacts/:id',
    meta: {
      entity,
      requiresAuth: true,
      requiresPermissionTo: 'contacts',
      crud: 'form'
    },
    component: () => import(/* webpackChunkName: 'contacts' */ '../../../views/Crud.vue')
  }
]
